import { render, staticRenderFns } from "./MunsterLevel.vue?vue&type=template&id=50fa73ca&scoped=true&"
import script from "./MunsterLevel.vue?vue&type=script&lang=js&"
export * from "./MunsterLevel.vue?vue&type=script&lang=js&"
import style0 from "./MunsterLevel.vue?vue&type=style&index=0&id=50fa73ca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fa73ca",
  null
  
)

export default component.exports